import { useEffect, useState } from 'react';
import { Box, Grid } from '@mui/material';
import { getDashboardData } from '../../services/Dashboard';
import { useNotify } from 'ra-core';
import TotalEmployeeCard from './components/cards/TotalEmployeeCard';
import WeeklyTransactionCard from './components/cards/WeeklyTransactionCard';
import TotalTerminalCard from './components/cards/TotalTerminalCard';
import WeeklyTransactionChart from './components/charts/WeeklyTransactionChart';
import SubMerchantRevenueChart from './components/charts/SubMerchantRevenueChart';
import TransactionTypesChart from './components/charts/TransactionTypesChart';

export default function Dashboard() {
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const notify = useNotify();
  const userRole = localStorage.getItem('userRole');

  useEffect(() => {
    const getData = async () => {
      let tmpData;
      try {
        tmpData = await getDashboardData();
        setData(tmpData);
        setIsLoading(false);
      } catch (error) {
        notify('Cannot get data!', { type: 'error' });
        setData(tmpData);
        setIsLoading(false);
      }
    };

    getData();
    // eslint-disable-next-line
  }, []);

  return (
    <Box
      sx={{
        ml: '16px',
        mr: '8px',
        my: '30px',
      }}
    >
      <Grid container spacing={3}>
        {/* Cashier doesn't have permission to get: allEmployees, allTerminals */}
        {userRole === '3' ? null : (
          <Grid item container xs={12} spacing={3}>
            <Grid item xs={12} md={4}>
              <TotalEmployeeCard isLoading={isLoading} data={data} />
            </Grid>
            <Grid item xs={12} md={4}>
              <TotalTerminalCard isLoading={isLoading} data={data} />
            </Grid>
            <Grid item xs={12} md={4}>
              <WeeklyTransactionCard isLoading={isLoading} data={data} />
            </Grid>
          </Grid>
        )}
        <Grid item xs={12} md={7}>
          <WeeklyTransactionChart data={data} isLoading={isLoading} />
        </Grid>
        <Grid item xs={12} md={5}>
          {userRole === '3' ? (
            <TransactionTypesChart data={data} isLoading={isLoading} />
          ) : (
            <SubMerchantRevenueChart data={data} isLoading={isLoading} />
          )}
        </Grid>
      </Grid>
    </Box>
  );
}
